export const NotificationSeenIdsLimit = 100
